export class Newsletter {
    public Id = '';
    public Name = '';
    public CreatedAt: Date | null = null;
    public UpdatedAt: Date | null = null;
    public Params: Array<string> = [];
    public FieldValues: NewsletterFieldValue[] = [];
    public HTML = '';
    public HtmlLinks: string[] = [];
    public PreviewPath: string | null = null;
    public IsTextTemplate = false;
}

export class NewsletterFieldValue {
    public Id = 0;
    public PageId: string | null = null;
    public Type: NewsletterFieldValueType | null = null;
    public Value = '';
    public Key = '';

    constructor(key: string, pageId: string, type: NewsletterFieldValueType) {
        this.Key = key;
        this.PageId = pageId;
        this.Type = type;
    }
}

export enum NewsletterFieldValueType {
    Static = 1,
    Form = 2,
}

export class NewslettersFilter {
    public Keywords?: string | null = null;
    public OrderBy: string | null = null;
    public IsTextTemplate = false;
}

export interface NewslettersFilterResult {
    Rows: Newsletter[];
}

export class NewsletterSaveRequest {
    public TemplateId = 0;
    public Name: string = '';
    public HTML: string = '';
    public IsTextTemplate = false;
}
